import {Box, Drawer, Link, useMediaQuery, useTheme, IconButton} from "@mui/material";
import {use, useRef, useState} from "react";
import {translateKey} from "utils/fieldsFormatters";
import {LanguageContext} from "context/LanguageContext";
import {BN_URL, KATALOG_BN_HOME_URL, PRZEPISY_BN_URL, API_URL} from "consts/khw-consts";
import terms from "assets/pdf/dbn_terms_pl_en.pdf"
import policy from "assets/pdf/dbn_policy_pl_en.pdf"
import accesibility_info from "assets/pdf/DD_KHW_DBN.pdf"
import ue_logo from "assets/eu-logo.jpg"
import CookieConsentBar from "./CookieConsentBar";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ReportSuggestionDialog from "../descriptorInfo/dialogs/ReportSuggestionDialog";

interface FooterProps {
    alwaysShowFooter: boolean
}

const Footer = ({alwaysShowFooter}: FooterProps) => {
    const {language} = use(LanguageContext);
    const footerRef = useRef(undefined)
    const theme = useTheme();

    const mobileView = useMediaQuery(theme.breakpoints.between('xs', 'md'));
    const [openDrawer, setOpenDrawer] = useState(false)
    const [openReportSuggestionForm, setopenReportSuggestionForm] = useState(false)

    const onClickContactLink = () => {
        setopenReportSuggestionForm(true)
    }

    const onCloseReportSuggestionForm = () => {
        setopenReportSuggestionForm(false)
    }
    const renderElements = (showCookie: boolean = true, mobile: boolean = false) => <>
        {showCookie && <CookieConsentBar className={alwaysShowFooter ? 'basic-cookie-fixed' : 'basic-cookie-standard'}
                                         footerHeight={'130px'}/>}


        <Box className={ mobile ? 'column': 'row'}  margin={'auto'}>
            {/*<Grid size={{md: 1}}/>*/}

            <Box className={mobile ? 'column footer-column-mobile' : 'column footer-column'}>
                <Link href={`${BN_URL}`} target={'_blank'}
                      title={translateKey('linkOpeningPageInNewTab', language)}>Biblioteka Narodowa</Link>
                <Link href={`${KATALOG_BN_HOME_URL}`} target={'_blank'}
                      title={translateKey('linkOpeningPageInNewTab', language)}>{translateKey('BNCatalogue', language)}</Link>
                <Link href={`${PRZEPISY_BN_URL}`} target={'_blank'}
                      title={translateKey('linkOpeningPageInNewTab', language)}>{translateKey('catalogingRegulations', language)}</Link>
            </Box>
            <Box className={mobile ? 'column footer-column-mobile' : 'column footer-column'}>

                <Link href={terms} rel="noreferrer" target="_blank"
                      title={translateKey('linkOpeningPageInNewTab', language)}>{translateKey('terms', language)}</Link>
                <Link href={policy} rel="noreferrer" target="_blank"
                      title={translateKey('linkOpeningPageInNewTab', language)}>{translateKey('privacyPolicy', language)}</Link>
                <Link href={accesibility_info} rel="noreferrer" target="_blank"
                      title={translateKey('linkOpeningPageInNewTab', language)}>{translateKey('accessibilityStatement', language)}</Link>
                <Link href={'/documentation'}>{translateKey('Documentation', language)}</Link>

            </Box>
            <Box className={mobile ? 'column footer-column-mobile' : 'column footer-column'}>
                <Link href={'/sitemap'}>{translateKey('Sitemap', language)}</Link>
                <Link onClick={onClickContactLink} className={'button-link'}
                      title={translateKey('linkOpeningPageInNewTab', language)}>{translateKey('Contact', language)}</Link>
                <Link href={`${API_URL}`} target={'_blank'}
                      title={translateKey('linkOpeningPageInNewTab', language)}>API</Link>

            </Box>
            {/*<Grid size={{md: 2}}/>*/}

            <Box style={{justifySelf: 'flex-end', float: 'right'}}>
                <img src={ue_logo} className={mobile ? 'eu-logo-mobile' : 'eu-logo'}
                     alt={translateKey('EULogoAlt', language)}/>
            </Box>
        </Box>


        <ReportSuggestionDialog open={openReportSuggestionForm}
                                onClose={onCloseReportSuggestionForm}/>
    </>

    const renderDesktopView = () => <Box
        className={alwaysShowFooter ? 'footer footer-fixed' : 'footer footer-standard'}
        role='contentinfo'
        ref={footerRef}>{renderElements()}</Box>

    const renderMobileView = () => <>


        <Box
            className={'mobile-footer-fixed'}
            role='contentinfo'
            ref={footerRef}
            // onClick={() => setOpenDrawer(true)}
        >

            <CookieConsentBar className={alwaysShowFooter ? 'basic-cookie-fixed' : 'basic-cookie-standard'}
                              footerHeight={'5vh'}/>
            <IconButton onClick={() => setOpenDrawer(true)} color={'secondary'}
                        className={'open-footer-btn'}><ExpandLessIcon/></IconButton>
            <Drawer
                anchor="bottom"
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
                ModalProps={{
                    keepMounted: true,
                }}
            >
                <Box className={'mobile-footer mobile-footer-open'}>


                    <IconButton onClick={() => setOpenDrawer(false)} color={'secondary'} className={'close-footer-btn'}><ExpandMoreIcon/></IconButton>
                    {renderElements(false, true)}
                </Box>
            </Drawer>
        </Box></>


    return <><h2
        className="screen-reader-text">{translateKey('footer', language)}</h2>{mobileView ? renderMobileView() : renderDesktopView()}</>
}

export default Footer